export default __webpack_public_path__ + "static/grid@2x-777ed4123de6bbe30e709a529eaa6143.png";